import styled from 'styled-components';
import Popper from '@mui/material/Popper';

export const Wrapper = styled.div`
  position: relative;
  z-index: 100;

  .cell {
    transition: all 0.4s ease;
    color: ${(props) => props.theme.primary.main};
    border: 1px solid ${(props) => props.theme.primary.main};

    &:hover,
    &.selected,
    &.today {
      background: ${(props) => props.theme.primary.main};
      color: #fff;
    }

    &.disabled {
      cursor: not-allowed;
      pointer-events: none;
      color: ${(props) => props.theme.datepicker.driver};
      border-color: ${(props) => props.theme.datepicker.driver};
    }
  }

  .more-date {
    font-size: 46px;
    color: ${(props) => props.theme.primary.main};
  }

  .navigation {
    color: ${(props) => props.theme.primary.main};
    font-size: 20px;

    &.prev {
      transform: rotate(180deg);
    }
  }

  .btn-navigation:disabled {
    .navigation {
      color: ${(props) => props.theme.datepicker.driver};
    }
  }

  .more-btn {
    padding: 0;
  }

  ${(props) => props.theme.breakpoints.down(460)} {
    .MuiButtonBase-root {
      &.btn-navigation {
        padding: 2px;
      }

      &.cell {
        padding: 2px;

        & > span {
          width: 28px;
          height: 28px;
        }
        span {
          font-size: 9px;
        }
      }
    }
  }
`;

export const PopperWrapper = styled(Popper)`
  top: -30px !important;
  left: 50% !important;
  width: 100%;
  transform: translate3d(-50%, 85.6px, 0px) !important;

  .react-datepicker,
  .react-datepicker__month-container {
    width: 100%;
  }

  .react-datepicker {
    .react-datepicker__day--outside-month,
    .react-datepicker__day--disabled {
      color: ${(props) => props.theme.datepicker.driver};
    }

    .react-datepicker__day-name,
    .react-datepicker__day {
      width: calc(100% / 7 - 6px);
    }

    .react-datepicker__day-names {
      margin-top: 15px;
    }

    .day-content {
      transition: all 0.4s ease;
    }

    .react-datepicker__day--keyboard-selected {
      background: transparent;
      color: ${(props) => props.theme.input.color};

      .day-content {
        border: 1px solid ${(props) => props.theme.primary.main};
      }
    }

    .react-datepicker__day--selected,
    .react-datepicker__day:hover,
    .react-datepicker__day--in-range {
      background: transparent;

      .day-content {
        background: ${(props) => props.theme.primary.main};
        color: #fff;
        line-height: 1;
      }
    }

    .react-datepicker__day--disabled:hover {
      .day-content {
        color: ${(props) => props.theme.datepicker.driver};
        background: transparent;
      }
    }
  }
`;
